export const CHANNEL_INFO_VIEW = {
  MAIN: 'main',
  MEMBERS: 'members',
  DETAILS: 'details',
  MEDIA: 'media',
};
